import {
  FETCH_LINEAR_CONFERENCE_REQUEST,
  FETCH_LINEAR_CONFERENCE_SUCCESS,
  FETCH_LINEAR_CONFERENCE_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  records: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_LINEAR_CONFERENCE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_LINEAR_CONFERENCE_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        records: action.payload,
      }

    case FETCH_LINEAR_CONFERENCE_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
